import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"width":"100%"},
  class: "p-d-flex p-jc-between p-ai-center"
}
const _hoisted_2 = { class: "p-py-2" }
const _hoisted_3 = { autocomplete: "off" }
const _hoisted_4 = { class: "p-inputgroup p-mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-inbox" })
], -1)
const _hoisted_6 = { class: "p-inputgroup" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" })
], -1)

import { useInviteResponsible } from "@/graphql/responsible/invite.responsible";


export default /*#__PURE__*/_defineComponent({
  __name: 'InviteResponsible',
  setup(__props) {

const {
  loading,
  hasError,
  form,
  submitInvitation,
  roles,
  visible,
  activeActivity,
} = useInviteResponsible();

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("responsible.title", { activity: _unref(activeActivity).name })), 1),
      (_unref(roles).length)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "pi pi-user-plus",
            class: "p-button-text",
            label: _ctx.$t('responsible.invite'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      visible: _unref(visible),
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      header: _ctx.$t('responsible.invitation', { activity: _unref(activeActivity).name })
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          loading: _unref(loading),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(submitInvitation)())),
          label: _ctx.$t('validate'),
          icon: "pi pi-send",
          "icon-pos": "right",
          style: {"width":"100%"},
          disabled: _unref(hasError) || _unref(loading)
        }, null, 8, ["loading", "label", "disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.$t("responsible.email")) + " ", 1),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              class: _normalizeClass({ 'p-invalid': _unref(form).email.$hasError }),
              modelValue: _unref(form).email.$value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).email.$value) = $event))
            }, null, 8, ["class", "modelValue"])
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("responsible.role")) + " ", 1),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Dropdown, {
              modelValue: _unref(form).role.$value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).role.$value) = $event)),
              options: _unref(roles),
              "option-label": "name",
              "option-value": "id",
              class: _normalizeClass({ 'p-invalid': _unref(form).role.$hasError })
            }, null, 8, ["modelValue", "options", "class"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}
}

})